<template>
  <div align="center" class="on-secondary">
    <h1 class="my-15">
      {{ t("views.paymentMethodSuccess.title") }}
    </h1>
    <v-img src="@/assets/img/splash.png" width="200px" class="mx-auto d-block" />
    <p class="my-15 font-italic">
      {{ t("views.paymentMethodSuccess.description") }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
